import { onboardingHelper } from './onboardingHelper'

export function weTeachHelper() {
    return {
        weTeachLogo: require('../assets/images/weteach.png'),
        arrow: require('../assets/images/arrow.svg'), 
        rows: [
            {
                reverse: false,
                heading: "danielson framework for teaching",
                text:
                    "The Danielson 2013 Framework for Teaching (FfT) is the rubric used for teacher development and observation/evaluation. It is used as a formative tool to develop teacher practice as well as a rubric for use when observing and evaluating teacher practice. This version of the rubric contains all 22 components across four domains.",
                imageUrl: require("../assets/images/danielson_resize.jpg"),
                imageAlt: "danielson framework image",
                link: "https://www.weteachnyc.org/resources/resource/danielson-2013-framework-teaching/",
                linkText: "Read More on WeTeachNYC"
            },
            {
                reverse: true,
                heading: "teacher self-reflection tool",
                text:
                    "This self-reflection tool is intended to support teachers in celebrating their growth and continuing to strengthen their practice. This tool can be used by teachers voluntarily as a resource to guide their thinking as they reflect on their instructional practice, including areas of strength, areas for growth, current support, and desired future support.",
                imageUrl: require("../assets/images/self_reflection_resize.jpg"),
                imageAlt: "self reflection tool image",
                link: "https://www.weteachnyc.org/resources/resource/teacher-self-reflection-tool/",
            }
        ],
        columns: [
            {  
                heading: "lesson self-reflection tool",
                text:
                "This resource contains a set of questions that teachers may use to self-assess their practice following a lesson. The questions guide teachers to reflect on evidence of student learning, lesson execution, planning, and next steps for professional development.",
                link: "https://www.weteachnyc.org/resources/resource/lesson-self-reflection-tool-TE/",
                linkText: "Read More on WeTeachNYC",
            },
            {
                heading: "component next steps resource",
                text:
                "These resources support teachers and school leaders with identifying next steps for a priority area connected to Danielson's Framework for Teaching (FfT) components. Each resource includes component-specific 'ask abouts', an Instructional Next Steps Idea Bank, and a set of collaborative discussion questions for teachers and school leaders.",
                link: "https://www.weteachnyc.org/resources/collection/danielson-framework-for-teaching-component-next-steps-resources/",
            }
        ],
        steps: [
            {
                element: '#weteach-link',
                intro: `${ onboardingHelper().closeIconText('doneWeTeachOnboarding') }
                    <h2>WETEACHNYC</h2>
                    <p>To find more free component-based resources, click the WeTeachNYC link here.</p>`,
                tooltipClass: 'hide-skip'
            },
            {
                element: '#need-help',
                intro: `${ onboardingHelper().closeIconText('doneWeTeachOnboarding') }
                    <h2>WETEACHNYC</h2>
                    <p>If you ever need a reminder, find the tutorial for any page in Growth Explorer here.</p>`,
                tooltipClass: 'last-step'
            }
        ],
        teacherStepOne: {
            intro: `${ onboardingHelper().closeIconText('doneWeTeachOnboarding') }
                <h2>WETEACHNYC</h2>
                <p>Use the WeTeachNYC tab to view a sample of resources to promote your professional development.</p>`
        },
        adminStepOne: {
            intro: `${ onboardingHelper().closeIconText('doneWeTeachOnboarding') }
                <h2>WETEACHNYC</h2>
                <p>Use the WeTeachNYC tab to view a sample of resources to promote professional development in your teachers.</p>`
        }
    }
}